export default "__VITE_ASSET__SS_95cKd__"